module.exports = __webpack_public_path__ + "static/media/badge_nid.e8969c0d.svg";